import React from "react";
import PropTypes from "prop-types";

const GlobalTable = ({ columns, data }) => {
  return (
    <div className="overflow-x-auto w-full">
      {data?.length > 0 ? (
        <table className="w-full border-separate border-spacing-y-2">
          <thead>
            <tr>
              {columns.map((column, index) => (
                <th
                  key={column.id}
                  className={`text-sm text-gray-500 font-semibold px-4 py-2 uppercase whitespace-nowrap border-b dark:border-white/30 ${
                    index === columns.length - 1 ? "text-right" : "text-center" && index === 0 ? "text-left" : ""
                  }`}
                >
                  {column.label}
                </th>
              ))}
            </tr>
          </thead>

          <tbody>
            {data.map((row, rowIndex) => (
              <tr key={rowIndex}>
                {columns.map((column, colIndex) => (
                  <td
                    key={column.id}
                    className={`whitespace-nowrap border-b dark:border-white/30 dark: px-4 py-3 text-sm ${
                      colIndex === columns.length - 1 ? "text-right" : "text-center" && colIndex === 0 ? "text-left" : "text-center"
                    }`}
                  >
                    {column.render
                      ? column.render(row, rowIndex)
                      : row[column.id]}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <p className="text-center text-gray-400 text-sm py-6">No data found</p>
      )}
    </div>
  );
};

GlobalTable.propTypes = {
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      render: PropTypes.func,
    })
  ).isRequired,
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default GlobalTable;
